import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const accountHeaderStyles = {
    groupAction: css`
        position: absolute;
        top: calc(100% + 3px);
        left: -160px;
        z-index: 3;
        border-radius: 16px;
        box-shadow: 1px 4px 4px 0px rgba(0, 0, 0, 0.5);
        overflow: hidden;
        transition: 0.25s;
        transform: translateY(-1px);
    `,
    groupActionInner: css`
        background: ${colors.white};
        padding: 20px;
        display: flex;
        gap: 12px;
        flex-direction: column;
    `,
    groupActionCol: css`
        display: flex;
        width: 590px;
        h6 {
            font-size: 14px;
            margin-bottom: 12px;
            width: 15%;
        }
    `,
    groupActionList: css`
        display: flex;
        gap: 10px;
        width: 85%;
    `,
    accountActionItem: css`
        padding: 6px 5px;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        text-align: center;
        cursor: pointer;
        transition: 0.25s;
        width: 160px;
        display: flex;
        align-items: center;
        img {
            width: 25px;
            margin-right: 5px;
        }
        p {
            font-size: 13px;
        }
        &:hover {
            background: #c3e9ff;
            border-color: #2d276d;
        }
    `,
};
export default accountHeaderStyles;
